import Phaser from 'phaser';

interface FogSource {
  worldX: number;
  worldY: number;
}

/**
 * Manages fog particle emitters for each fog machine.
 * Emits a puff on each beat, with continuous ambient drift.
 */
export class FogParticleSystem {
  private scene: Phaser.Scene;
  private emitters: Phaser.GameObjects.Particles.ParticleEmitter[] = [];

  constructor(scene: Phaser.Scene) {
    this.scene = scene;
  }

  setSources(sources: FogSource[]): void {
    this.destroy();

    for (const src of sources) {
      const emitter = this.scene.add.particles(src.worldX, src.worldY - 12, 'fog-particle', {
        speed: { min: 5, max: 20 },
        angle: { min: 240, max: 300 },
        scale: { start: 0.5, end: 1.5 },
        alpha: { start: 0.3, end: 0 },
        lifespan: 3000,
        frequency: 200,
        blendMode: Phaser.BlendModes.ADD,
        quantity: 1,
      });
      emitter.setDepth(300);
      this.emitters.push(emitter);
    }
  }

  /** Puff on beat - burst extra particles */
  onBeat(_beatCount: number): void {
    for (const emitter of this.emitters) {
      emitter.emitParticle(5);
    }
  }

  destroy(): void {
    for (const emitter of this.emitters) {
      emitter.destroy();
    }
    this.emitters = [];
  }
}
